import { render, staticRenderFns } from "./NuevaAlergia.vue?vue&type=template&id=30552896"
import script from "./NuevaAlergia.vue?vue&type=script&lang=js"
export * from "./NuevaAlergia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports